//frontend/src/auth/ProtectedRoute.tsx
import React from 'react';
import type { ReactElement } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation, Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }: { children: ReactElement }) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const location = useLocation();

  if (isLoading) return <div>Loading…</div>;

  // If Auth0 redirected back with an error, don’t loop
  const params = new URLSearchParams(location.search);
  if (params.get('error') === 'access_denied') {
    return <Navigate to={`/access-denied${location.search}`} replace />;
  }

  if (!isAuthenticated) {
    loginWithRedirect({
      appState: { returnTo: location.pathname + location.search },
    });
    return <div>Redirecting to login…</div>;
  }

  return children;
}
